export default __webpack_public_path__ + "static/media/activities.68b91a82.PNG";